import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as loginReducer from "containers/Login/reducer";
import * as marketplaceReducer from "containers/Marketplace/reducer";

import Marketplace from "components/Marketplace/Marketplace";

class MarketplaceContainer extends React.PureComponent {
  render() {
    return <Marketplace {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  purchaseBlueprint: (id) => dispatch(marketplaceReducer.purchaseBlueprint(id)),
  unpublishBlueprint: (id) => dispatch(marketplaceReducer.unpublishBlueprint(id)),
  selectMarketplace: (id) => dispatch(marketplaceReducer.selectMarketplace(id))
});

const mapStateToProps = (state) => {
  const selectedMarketplace = marketplaceReducer.getSelectedMarketplace(state);
  const offers = selectedMarketplace ? marketplaceReducer.getMarketplaceOffersArr(state, selectedMarketplace.id) : [];
  return {
    marketplaces: marketplaceReducer.getMarketplaceArr(state),
    selectedMarketplace: selectedMarketplace,
    offers: offers,
    isLoading: marketplaceReducer.getIsLoading(state),
    userId: loginReducer.getUserID(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketplaceContainer);
